import React, { useState, useEffect } from "react";
import Pagination from 'react-bootstrap/Pagination';
import Container from 'react-bootstrap/Container';

const columns = [
    { name: 'id', header: 'Order ID', defaultFlex: 1 },
    { name: 'items', header: 'Items', defaultFlex: 1,
        render: ({ data }) => (
            data.order_items.map(item => (
                <>{item.sizeName}<br/ ></>
            ))
        ) },
  { name: 'deliveryName', header: 'deliveryName', maxWidth: 1000, defaultFlex: 4 },
];

const gridStyle = { minHeight: 550 }


const MSMPagination = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(props.perPage);
  
  let pageItems = [];
  let pages = 0;

  useEffect(() => {
    setCurrentPage(1);
  }, [props.reset]);

  useEffect(() => {
    if (props.perPage) setPerPage(props.perPage);
  }, [props.perPage]);

  const gotoPage = (pagenum) => {
    if(pagenum === 'first') {
        if(currentPage == 1) return;
        pagenum = 1;
    } else if(pagenum === 'next') {
        if(currentPage + 1 <= pages) 
            pagenum = currentPage +1;
        else return;
    } else if(pagenum === 'prev') {
        if(currentPage - 1 >= 1) 
            pagenum = currentPage - 1;
        else return;
    } else if(pagenum === 'last') {
        if(currentPage === pages) return;
        pagenum = pages;
    } 

    console.log(pagenum);
    setCurrentPage(pagenum);
    const range = [ pagenum, perPage ];
    props.reload(range);
  }

    pages = Math.ceil(props.total/perPage) || 0;

    // Sliding window of page numbers so large totals stay usable
    const windowSize = 7;
    let startPage = 1;
    let endPage = pages;
    if (pages > windowSize) {
      const half = Math.floor(windowSize / 2);
      startPage = Math.max(1, currentPage - half);
      endPage = Math.min(pages, startPage + windowSize - 1);
      startPage = Math.max(1, endPage - windowSize + 1);
    }

    pageItems.push(<Pagination.First key="first" disabled={currentPage <= 1 || pages === 0} onClick={() => gotoPage("first")}/>);
    pageItems.push(<Pagination.Prev  key="prev" disabled={currentPage <= 1 || pages === 0} onClick={() => gotoPage("prev")}/>);

    if (startPage > 1) {
      pageItems.push(
        <Pagination.Item key={1} active={currentPage === 1} onClick={() => gotoPage(1)}>1</Pagination.Item>
      );
      if (startPage > 2) {
        pageItems.push(<Pagination.Ellipsis key="start-ellipsis" disabled />);
      }
    }

    for (var i = startPage; i <= endPage; i++) {
        let idx = i;
        pageItems.push(
            <Pagination.Item key={i} active={i === currentPage} onClick={() => gotoPage(idx)}>
            {i}
            </Pagination.Item>
        )
    }

    if (endPage < pages) {
      if (endPage < pages - 1) {
        pageItems.push(<Pagination.Ellipsis key="end-ellipsis" disabled />);
      }
      pageItems.push(
        <Pagination.Item key={pages} active={currentPage === pages} onClick={() => gotoPage(pages)}>{pages}</Pagination.Item>
      );
    }

    pageItems.push(<Pagination.Next  key="next" disabled={currentPage >= pages || pages === 0} onClick={() => gotoPage("next")}/>);
    pageItems.push(<Pagination.Last  key="last" disabled={currentPage >= pages || pages === 0} onClick={() => gotoPage("last")}/>);


    return (
        <div className="msmpagination-container">
            <Pagination key="pagination">
                {pageItems}
            </Pagination>
        </div>
    );
};
export default MSMPagination;

